// extracted by mini-css-extract-plugin
export default {"collapsible":"nb4vEA","header":"uand76","title":"SbiKiT","collapseButton":"JA2FRK","body":"C27Cai"};